var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.blockClassName]},[(!_vm.itIsLibaryIcon)?[_c(_vm.setIcon,{tag:"component",attrs:{"color":_vm.color,"status":_vm.status}})]:_c('atoms-icons-font-libary',{attrs:{"color":_vm.color,"icon":_vm.icon,"modifiers":_vm.modifiers},on:{"click":function($event){return _vm.$emit('click')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }